import { environment } from '@env/environment';
import { firstValueFrom } from 'rxjs';
import { AuthService } from '@core/auth/services/auth.service';
import { AppModeService } from '@core/services/app-mode.service';
import { IndiceService } from '@features/admin/indice/services/indice.service';

export function appModeInitializer(
   appModeService: AppModeService,
   congresoServiceIndice: IndiceService,
   authService: AuthService
): () => Promise<void> {
   return async () => {
      const currentHost = window.location.hostname.toLowerCase();
      const adminHost = String(environment.DOMINIO_ADMIN || '').toLowerCase();

      if (currentHost === adminHost) {
         appModeService.setAdmin();
      } else {
         // Desarrollo local: localhost, 127.0.0.1 y *.localhost (p. ej. uncongreso.localhost)
         // no existen en sgi_indice, así que se resuelve contra el host de pruebas del
         // environment (URL_CONGRESO_HOST). En prod/demo ese valor va vacío y se usa
         // siempre el dominio real del navegador.
         const esLocalhost =
            currentHost === 'localhost' ||
            currentHost === '127.0.0.1' ||
            currentHost.endsWith('.localhost');
         const hostCongreso = esLocalhost && environment.URL_CONGRESO_HOST
            ? String(environment.URL_CONGRESO_HOST).toLowerCase()
            : currentHost;

         try {
            const congreso = await firstValueFrom(congresoServiceIndice.resolveCongresoByUrl(hostCongreso, true));

            if (congreso?.id) {
               authService.setSgiindice(Number(congreso.id));
               appModeService.setCongreso(congreso);
            } else {
               appModeService.setUnknown();
            }
         } catch {
            appModeService.setUnknown();
         }
      }
   };
}
